import React from 'react';

interface EditorPageNavProps {
  currentPage: number; // 0-indexed
  pageCount: number;
  onChangePage: (page: number) => void;
}

/**
 * 複数ページ PDF のページ送り UI。 pageCount <= 1 のときは何も描画しない。
 * FingeringEditorPage から issue #17 Phase 2 で抽出。
 */
const EditorPageNav: React.FC<EditorPageNavProps> = ({ currentPage, pageCount, onChangePage }) => {
  if (pageCount <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-2 py-1.5 bg-slate-800 border-b border-slate-700 flex-shrink-0">
      <button
        onClick={() => onChangePage(Math.max(0, currentPage - 1))}
        disabled={currentPage === 0}
        className="px-2 py-0.5 text-sm rounded-lg border border-slate-600 text-slate-300 hover:bg-slate-700 disabled:opacity-30 disabled:cursor-default"
      >
        ◀
      </button>
      <span className="text-xs text-slate-400 font-medium">{currentPage + 1} / {pageCount}</span>
      <button
        onClick={() => onChangePage(Math.min(pageCount - 1, currentPage + 1))}
        disabled={currentPage >= pageCount - 1}
        className="px-2 py-0.5 text-sm rounded-lg border border-slate-600 text-slate-300 hover:bg-slate-700 disabled:opacity-30 disabled:cursor-default"
      >
        ▶
      </button>
    </div>
  );
};

export default EditorPageNav;
